import type Address from "@/models/questions/address";
import {
  AnswerKeyPersonnel,
  KeyPersonnel,
} from "@/models/persons/keyPersonnel";

export class BeneficialOwner extends KeyPersonnel {
  address: Address;
  share: string;

  constructor(beneficialOwner?: AnswerBeneficialOwner) {
    super(beneficialOwner);
    if (beneficialOwner == undefined) {
      this.address = { street: "", city: "", country: "", region: "" };
      this.share = "";
    } else {
      this.address = {
        street: beneficialOwner.address?.street ?? "",
        city: beneficialOwner.address?.city ?? "",
        country: beneficialOwner.address?.country ?? "",
        region: beneficialOwner.address?.region ?? "",
      };
      this.share = beneficialOwner.share;
    }
  }

  toAnswerModel(): AnswerBeneficialOwner {
    return new AnswerBeneficialOwner(this);
  }
}

export class AnswerBeneficialOwner extends AnswerKeyPersonnel {
  address: Address;
  share: string;

  constructor(beneficialOwner: BeneficialOwner) {
    super(beneficialOwner);
    this.address = {
      street: beneficialOwner.address?.street ?? "",
      city: beneficialOwner.address?.city ?? "",
      country: beneficialOwner.address?.country ?? "",
      region: beneficialOwner.address?.region ?? "",
    };
    this.share = beneficialOwner.share;
  }
}
